<template>
  <filter-term
    v-bind="$props"
    v-on="listeners"
    @update:errors="interceptErrors"
  />
</template>

<script>
// 選択可能な日数を制限する期間選択コンポーネント

import moment from 'moment'

import FilterTerm from '@/components/FilterTerm.vue'
import ErrorReport from '@/mixins/ErrorReport'

export default {
  mixins: [ErrorReport],
  components: { FilterTerm },
  props: {
    termType: {
      type: String,
      default: 'w',
    },
    dateFrom: {
      type: String,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
    dateTo: {
      type: String,
      validator(value) {
        const regex = new RegExp(/^\d{8}$/g)
        return regex.test(value)
      },
    },
    defaultWeekCount: {
      type: Number,
      default: 13,
    },
    weekType: {
      type: String,
      default: 'COUNT_FROM',
    },
    // 選択可能な日数のデフォルト値
    max: {
      type: Number,
      default: 365,
    },
  },
  data() {
    return {
      childErrors: [],
    }
  },
  computed: {
    errors() {
      const errors = []

      if (this.dateFrom && this.dateTo) {
        const dateFrom = moment(this.dateFrom)
        const dateTo = moment(this.dateTo)

        if (dateTo.diff(dateFrom, 'days') + 1 > this.max) {
          errors.push(`選択可能な日数を超えています（最大${this.max}日）`)
        }
      }

      return [...errors, ...this.childErrors]
    },
    listeners() {
      // eslint-disable-next-line no-unused-vars
      const { 'update:errors': _, ...rest } = this.$listeners
      return rest
    },
  },
  methods: {
    interceptErrors(errors) {
      this.childErrors = errors
    },
  },
}
</script>
